<template lang="pug">
    span(class="_marq", :class="pan && '_pan'")
        span(ref="shim")
            slot
</template>

<script>
    const hold = 1000;
    const interval = 3000;

    /**
    * This component reacts to a horizontal overflow of its content by horizontally
    * panning in an oscillating manner.
    */
    export default {
        name: 'ib-marquee',

        data() {
            return {
                pan: false,
                timeout: 0,
                observer: null
            };
        },

        mounted() {
            this.mutate();
            if (window.MutationObserver) {
                this.observer = new MutationObserver(this.mutate);
                this.observer.observe(this.$refs.shim, {
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        },

        destroyed() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },

        methods: {
            mutate() {
                this.pan = false;
                this.delta = this.$el.clientWidth - this.$el.scrollWidth;
                Object.assign(this.$refs.shim.style, this.$util.transform({ tx: 0 }));

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                if (this.delta < 0) {
                    this.timeout = setTimeout(this.toEnd, hold);
                } else {
                    this.timeout = 0;
                }
            },

            toStart() {
                Object.assign(this.$refs.shim.style, this.$util.transform({ tx: 0 }));
                this.timeout = setTimeout(this.toEnd, interval + hold);
                this.pan = true;
            },

            toEnd() {
                Object.assign(this.$refs.shim.style, this.$util.transform({ tx: this.delta }));
                this.timeout = setTimeout(this.toStart, interval + hold);
                this.pan = true;
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._marq {
        display: inline-block;
        max-width: 100%;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;

        > span {
            display: inline-block;
            will-change: transform;
        }
        &._pan > span {
            transition: transform 3s linear;
        }
    }
</style>

<docs>
    Basic Example
    ```jsx
        <ib-context>
            <ib-marquee>This is the longest text in the world. If the text is longer than the size of the ib-marquee, then it will begin to scroll automatically because it's basically magic.</ib-marquee>
        </ib-context>
    ```
</docs>
